module.exports = __webpack_public_path__ + "static/media/help.b2e4a4a0.svg";